// extracted by mini-css-extract-plugin
export default {"errorNotification":"Notification_errorNotification__1AZsF","isError":"Notification_isError__5Ilep","show":"Notification_show__s+XMw","hide":"Notification_hide__RYx21"};